/** @jsxRuntime classic */
import React from 'react';
import { Select } from 'antd';
import type { ViewableInfo } from '~src/hooks/svf-viewer-hooks/useViewables';

type Props = {
  viewables: ViewableInfo[];
  activeGuid?: string;
  onChange: (guid: string) => void;
};

const ViewSelector: React.FC<Props> = ({ viewables, activeGuid, onChange }) => {
  // Always render; if nothing yet, show disabled placeholder
  const hasItems = Array.isArray(viewables) && viewables.length > 0;
  const value = activeGuid ?? viewables[0]?.guid;

  return (
    <Select
      size="small"
      value={value}
      style={{ minWidth: 240 }}
      onChange={onChange}
      placeholder={hasItems ? 'Choose a view' : 'No views'}
      dropdownMatchSelectWidth={false}
      optionFilterProp="children"
      getPopupContainer={() => document.body}
      dropdownStyle={{ zIndex: 100000 }}
      dropdownClassName="svf-viewer-select-dropdown"
      disabled={!hasItems}>
      {viewables.map((v) => (
        <Select.Option key={v.guid} value={v.guid}>
          {v.name} {v.role ? `(${v.role})` : ''}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ViewSelector;
